export default {"src":"/_next/static/media/visual_search_small.97683ec1.svg","height":20,"width":20};